// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VebWI","manufacturer":"styles_manufacturer__EoCOt","total":"styles_total__aKSoR"};